import Vue from "vue";

import DataWebConfig from "@Scripts/Config/DataWebConfig";
import AppConfig from "@Scripts/Config/AppConfig";
import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";
import Axios from "axios";

import ResponsiveHelper from "@Scripts/Infrastructure/ResponsiveHelper";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "Newsletter", "NewsletterSubscribe", "CookieToast", "Seo", "Magazine"]
        });

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        this.initRequestVerificationToken();

        AppConfig.AddComponents();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        ResponsiveHelper.onResize();

        this.setExpandingMenu();
        this.setSearchOpen();
        this.setShowCategory();
        this.setCookieToast()
        this.setGoTop();
        this.setAnalytics();
        this.setShare();
        this.setContextMenu();
        this.setVisuals();
        this.setShowBookingMap();
        this.setCloseStickyBanner();
        this.openNewsletterDialog();
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static openNewsletterDialog() {
        let ctas = document.querySelectorAll(".is-newsletterdialog");
        for (const item of ctas) {
            item.addEventListener("click", x => {
                (<any>window).App.instances.vm.$store.commit("newsletterStore/setNewsletterSubscribeVisible", true);
            })
        }
    }

    public static setShare() {
        $(".open-share").on("click", function () {
            $(".share").toggleClass("show");
        });

        $(document).on("click", function (event) {
            if (!$(event.target).parents().hasClass("share")) {
                $(".share").removeClass("show");
            }
        });
    }

    public static setCookieToast() {
        var $cookieToast = $(".cookie-toast"),
            $customizeBox = $(".customize", $cookieToast),
            $buttonAcceptAll = $("#ButtonAcceptAll", $cookieToast),
            $buttonOnlyTech = $("#ButtonOnlyTech", $cookieToast),
            $buttonCustomize = $("#ButtonCustomize", $cookieToast),
            $buttonActivateStatistics = $("#ButtonActivateStatistics", $customizeBox),
            $buttonDeactivateStatistics = $("#ButtonDeactivateStatistics", $customizeBox),
            $buttonActivateProfiling = $("#ButtonActivateProfiling", $customizeBox),
            $buttonDeactivateProfiling = $("#ButtonDeactivateProfiling", $customizeBox),
            $buttonSaveCustomize = $("#ButtonCustomizeSave", $customizeBox),
            customizeCookieValues = ["tech"];

        if (!CookieHelper.isCookiePolicy()) {
            $cookieToast.slideDown();
        }

        $buttonAcceptAll.on("click", function () {
            CookieHelper.setCookiePolicyAll();
            $cookieToast.slideUp();
            GTagHelper.sendEvent("click", { cookie_toast: "accept" });
        });

        $buttonOnlyTech.on("click", function () {
            CookieHelper.removeCookiePolicyAll();
            $cookieToast.slideUp();
            GTagHelper.sendEvent("click", { cookie_toast: "only tech" });
        });

        $buttonCustomize.on("click", function () {
            $customizeBox.slideToggle();
        });

        $buttonActivateStatistics.on("click", function () {
            $buttonActivateStatistics.hide();
            $buttonDeactivateStatistics.show();
            customizeCookieValues.push("stat");
        });

        $buttonDeactivateStatistics.on("click", function () {
            $buttonDeactivateStatistics.hide();
            $buttonActivateStatistics.show();
            var index = customizeCookieValues.indexOf("stat");
            if (index !== -1) {
                customizeCookieValues.splice(index, 1);
            }
        });

        $buttonActivateProfiling.on("click", function () {
            $buttonActivateProfiling.hide();
            $buttonDeactivateProfiling.show();
            customizeCookieValues.push("profile");
        });

        $buttonDeactivateProfiling.on("click", function () {
            $buttonDeactivateProfiling.hide();
            $buttonActivateProfiling.show();
            var index = customizeCookieValues.indexOf("profile");
            if (index !== -1) {
                customizeCookieValues.splice(index, 1);
            }
        });

        $buttonSaveCustomize.on("click", function () {
            CookieHelper.setCookie("ckp", customizeCookieValues.join("|"), 365);
            $cookieToast.slideUp();
            GTagHelper.sendEvent("click", { cookie_toast: "custom" });
        });
    };

    public static setGoTop() {
        var $gotop = $(".gotop");

        $(window).on("scroll", function () {
            if ($(this).scrollTop() >= 150) {
                $gotop.attr("data-fixed", "true");
            } else {
                $gotop.removeAttr("data-fixed");
            }
        });
    }

    public static setExpandingMenu() {
        var $item = $(".expmenu .item");
        $(".button-exp", $item).off("click").on("click", function () {
            var $itemCurrent = $(this).parent();

            $($item).not($($itemCurrent)).removeClass("show");
            $($itemCurrent).toggleClass("show");
        });
    };

    public static setSearchOpen() {
        var $buttonOpen = ".button-open-search",
            $search = ".app-search",
            $wrapTap = ".wrap-tap",
            $closeButton = ".icon.close";

        $($buttonOpen).off("click").on("click", function () {
            $($wrapTap).fadeIn();
            $($search).attr("data-show", "true");
            $("input.textbox", "#SearchBox")[0].focus();
        });

        $($closeButton).add($wrapTap).off("click").on("click", function () {
            $($wrapTap).fadeOut();
            $($search).removeAttr("data-show");
        });
    }

    public static setAnalytics() {
        $(document.body).on("click", ".ga-event", function (e) {
            switch ($(this).attr("data-ga-cat")) {
                case "Visual":
                    GTagHelper.sendEvent("click", { home_visual: $(this).attr("data-ga-label") });
                    break;
                case "Highlight":
                    GTagHelper.sendEvent("click", { home_highlight: $(this).attr("data-ga-label") });
                    break;
                case "HomeSearch":
                    GTagHelper.sendEvent("search", { home_search_to_detail: $(this).attr("data-ga-label") });
                    break;
                case "HeaderSearch":
                    GTagHelper.sendEvent("search", { header_search_to_detail: $(this).attr("data-ga-label") });
                    break;
                case "SocialShare":
                    GTagHelper.sendEvent("click", { social_share_type: "generic", social_share_name: $(this).attr("data-ga-label") });
                    break;
                case "SocialHeader":
                    GTagHelper.sendEvent("click", { social_share_type: "header", social_share_name: $(this).attr("data-ga-label") });
                    break;
                case "SocialFooter":
                    GTagHelper.sendEvent("click", { social_share_type: "footer", social_share_name: $(this).attr("data-ga-label") });
                    break;
                case "SocialNewsletter":
                    GTagHelper.sendEvent("click", { social_share_type: "newsletter", social_share_name: $(this).attr("data-ga-label") });
                    break;
                case "RelatedDestination":
                    GTagHelper.sendEvent("click", { related_page_type: "destination", related_page_title: $(this).attr("data-ga-label") });
                    break;
                case "RelatedNews":
                    GTagHelper.sendEvent("click", { related_page_type: "news", related_page_title: $(this).attr("data-ga-label") });
                    break;
                case "RelatedAirport":
                    GTagHelper.sendEvent("click", { related_page_type: "airport", related_page_title: $(this).attr("data-ga-label") });
                    break;
                case "RelatedShoppingPosts":
                    GTagHelper.sendEvent("click", { related_page_type: "shopping post", related_page_title: $(this).attr("data-ga-label") });
                    break;
                case "RelatedAirline":
                    GTagHelper.sendEvent("click", { related_page_type: "airline", related_page_title: $(this).attr("data-ga-label") });
                    break;
                case "RelatedLuxury":
                    GTagHelper.sendEvent("click", { related_page_type: "luxury", related_page_title: $(this).attr("data-ga-label") });
                    break;
                case "LuxuryNews":
                    GTagHelper.sendEvent("click", { luxury_news: $(this).attr("data-ga-label") });
                    break;
                case "Magazine_ReadNow":
                    GTagHelper.sendEvent("click", { magazine_cta_type: $(this).attr("data-read"), magazine_type: $(this).attr("data-ga-action").toLocaleLowerCase(), magazine_title: $(this).attr("data-ga-label") });
                    break;
                case "PostCategory":
                    GTagHelper.sendEvent("click", { content_category_type: "post", content_category_name: $(this).attr("data-ga-label") });
                    break;
                case "MagazineCategory":
                    GTagHelper.sendEvent("click", { content_category_type: "magazine", content_category_name: $(this).attr("data-ga-label") });
                    break;
            }
        });

        $(".ga-event-anchor").on("click", function (e) {
            switch ($(this).attr("data-ga-cat")) {
                case "GoTop":
                    GTagHelper.sendEvent("click", { scroll_up: "top" });
                    break;
                case "DestinationDetailNavigation":
                    GTagHelper.sendEvent("click", { content_detail_type: "destination", content_detail_name: $(this).attr("data-ga-label") });
                    break;
                case "AirportDetailNavigation":
                    GTagHelper.sendEvent("click", { content_detail_type: "airport", content_detail_name: $(this).attr("data-ga-label") });
                    break;
                case "AirportDetailNavigation":
                    GTagHelper.sendEvent("click", { content_detail_type: "airline", content_detail_name: $(this).attr("data-ga-label") });
                    break;
            }
        });

        $(".editor a").on("click", function () {
            GTagHelper.sendEvent("click", { page_click: $(this).attr("href") });
        });

        $(".ga-event-global[data-gaevent=\"true\"]").on("click", function () {
            switch ($(this).attr("data-gacategory")) {
                case "Banner":
                    GTagHelper.sendEvent("click", { banner_click: $(this).attr("data-galabel") });
                    break;
            }
        });

        document.querySelectorAll(".ga-event-global[data-gacategory='Banner']").forEach(element => {
            GTagHelper.sendEvent("click", { banner_impression: element.getAttribute("data-galabel") });
        });
    }

    public static setShowCategory() {
        var $list = $(".category-list"),
            $open = $(".category-button .open"),
            $close = $(".category-button .close");

        $($open).off("click").on("click", function () {
            $($list).slideDown();
            $($open).hide();
            $($close).show();
        });

        $($close).off("click").on("click", function () {
            $($list).slideUp();
            $($close).hide();
            $($open).show();
        });
    }

    public static setShowBookingMap() {
        $(".booking-map .button").off("click").on("click", function () {
            $(".booking-map .map").toggleClass("show");
            GTagHelper.sendEvent("click", { booking_map: "open" });
        });
    }

    public static setFancybox() {
        $("[data-fancybox]").on("click", function () {
            (<any>$).fancybox.open({
                fullScreen: false,
                thumbs: false,
                slideShow: false,
                iframe: {
                    scrolling: "auto"
                },
                image: {
                    protect: true
                }
            });
        });
    }

    public static setNewsletterDialog() {
        $("a[data-newsletter").on("click", function () {
            (<any>$).fancybox.open({
                src: (<any>window).App.routes.Account_NewsletterSubscribe,
                type: 'iframe'
            });
        });
    }

    public static setCloseStickyBanner() {
        $(".close-adv").on("click", function () {
            $(".banner-area[data-sticky]").hide();
        });
    }

    public static setContextMenu() {
        $("body").on("contextmenu", function (e) {
            e.preventDefault();

            $(".tooltip").css({
                top: e.pageY + "px",
                left: e.pageX + "px"
            }).addClass("show");

            $(".tooltip").on("click", function (e) {
                e.stopPropagation();
            });

            $("body").on("click", function () {
                $(".tooltip").removeClass("show");
            });
        });
    }

    private static setVisuals() {
        const visuals = new (<any>window).Swiper(".swiper-container", {
            modules: [(<any>window).Autoplay, (<any>window).EffectFade, (<any>window).Lazy, (<any>window).Pagination],
            loop: true,
            effect: "fade",
            autoplay: {
                delay: 4000
            },
            preloadImages: false,
            lazy: {
                loadOnTransitionStart: true,
                loadPrevNext: true
            },
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: false,
                renderBullet: function (index, className) {
                    return "<div class=\"item \ " + className + "\"><a href=\"" + (<any>window).App.bag.Visuals[index].linkUrl + "\" target=\"_self\" class=\"button ga-event\" data-ga-cat=\"Visual\" data-ga-action=\"Click\" data-ga-label=\"" + (<any>window).App.bag.Visuals[index].title + " " + (<any>window).App.bag.Visuals[index].abstract + "\"><div class=\"box\"><div class=\"title\">" + (<any>window).App.bag.Visuals[index].title + "</div><div class=\"abstract\">" + (<any>window).App.bag.Visuals[index].abstract + "</div></div></a></div>";
                }
            }
        });
    }
}